export const cortexAgentRunQuery = "/cortex_agent/run_query";
